module.exports = __webpack_public_path__ + "static/media/cloud.25ba9b82.svg";